import { render, staticRenderFns } from "./business_info.vue?vue&type=template&id=1f75589e&"
import script from "./business_info.vue?vue&type=script&lang=ts&"
export * from "./business_info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports